import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={784}
    height={props.width? `calc( ${props.width}/ 784 * 1080 )`: 1080}
    viewBox="0 0 784 1080"
    fill="none"
    {...props}
  >
    <g filter="url(#anb)">
      <path
        fill="#fff"
        fillOpacity={.9}
        d="m301.811 238.571 68.343-68.343h560.457v740.086H370.154l-68.343-68.342V238.571Z"
      />
    </g>
    <path
      stroke="#2CCFD9"
      strokeWidth={2}
      d="M370.043 170.229 301.7 238.571v603.401l68.343 68.342"
    />
    <defs>
      <filter
        id="anb"
        width={708.8}
        height={820.086}
        x={261.812}
        y={130.229}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation={20} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_58_4788"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_58_4788"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
export default SvgComponent
